const interactive = {
	visibleSection(target, position, offset = 0) {
		if(!target) return ;
		let visible = false;
		const targetPosition = {
				top: window.scrollY + target.getBoundingClientRect().top,
				bottom: window.scrollY + target.getBoundingClientRect().bottom,
				center: window.scrollY + target.getBoundingClientRect().top,
			},
			windowPosition = {
				top: window.scrollY,
				bottom: window.scrollY + document.documentElement.clientHeight
			};

		if (position === 'top') {
			targetPosition.top -= offset;
			if (targetPosition.top < windowPosition.top &&
				windowPosition.top < targetPosition.bottom) {
				visible = true;
			}
		}

		if (position === 'bottom') {
			targetPosition.top += offset;
			if (targetPosition.bottom > windowPosition.top &&
				targetPosition.top < windowPosition.bottom) {
				visible = true;
			}
		}

		if (position === 'center') {
			targetPosition.center += offset;
			if (targetPosition.center < windowPosition.top +
				(document.documentElement.clientHeight / 2) &&
				windowPosition.top < targetPosition.bottom) {
				visible = true;
			}
		}

		return visible;
	},

	scroller: function () {
		let count = 25;

		if(window.innerWidth <= 576) {
			count = 20;
		}

		if(this.container) {
			this.container.style.transform = `translateX(-${this.translateX}px)`;
		}

		if(this.visibleSection(this.container, 'bottom')) {
			if (window.scrollY >= this.lastScroll) {
				if(this.translateX > 0) {
					this.translateX -= count;
				}
			} else {
				if(this.translateX < this.container.scrollWidth) {
					this.translateX += count;
				}
			}
		}

		this.lastScroll = window.scrollY;
	},

	init: function () {
		this.container = document.querySelector(`[data-interactive-container]`);

		if(this.container) {
			this.translateX = this.container.scrollWidth;
			console.log({container: this.container})
			this.lastScroll = 0;
			this.container.style.transform = `translateX(-${this.translateX}px)`;
		}
	}
}

document.addEventListener('DOMContentLoaded', () => {
	interactive.init();
})

document.addEventListener('scroll', () => {
	interactive.scroller();
})
